import BaseModel from '../core/BaseModel'
export default class UserModel extends BaseModel {

    constructor() {
        super({ 
                name: "account",
                tableName: 'accounts', 
                label: "Quản lý người dùng"
            }, 
            {
            stt: {
                name: "stt",
                label: "STT",
                type: "Computed",
                computed: (data, index) => {
                    data.stt = index + 1;
                }
            },
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false
            },
            account: { 
                name: 'account', 
                type: "String", 
                label: 'Account', 
                sortable: false
            }
        },)
    }

}